module.exports = __webpack_public_path__ + "static/media/gmc.f6c409c1.png";